import { RootState } from '../../Presentation/store';
import { Notice } from '../Model/Notice';

export const selectNotices = (s: RootState): Notice[] =>
  Array.isArray(s.notice.list) ? s.notice.list : [];

export const selectNoticeLoading = (s: RootState): boolean => s.notice.loading;
